export default pr_area => {
    // let name = pr_area.name.trim().toLowerCase().replace(' ', '_');
    let name = pr_area.name.trim().toLowerCase().split(' ').join('_');
    return `/practice-area/${name}`;
};